import { type RecurringExamEventCreationFormType } from './schema';

export function getDefaultValues(defaultValuesOverride?: RecurringExamEventCreationFormType) {
  const defaultValues: RecurringExamEventCreationFormType = {
    examEventName: defaultValuesOverride?.examEventName ?? '',
    registrationType: defaultValuesOverride?.registrationType ?? null,
    examineeImportMethod: defaultValuesOverride?.examineeImportMethod ?? null,
    examDateGroup: {
      date: defaultValuesOverride?.examDateGroup?.date ?? [],
      examRecurringStartDate: defaultValuesOverride?.examDateGroup?.examRecurringStartDate ?? null,
      examRecurringEndDate: defaultValuesOverride?.examDateGroup?.examRecurringEndDate ?? null,
      startTime: defaultValuesOverride?.examDateGroup?.startTime ?? null,
      endTime: defaultValuesOverride?.examDateGroup?.endTime ?? null,
    },

    examCourses: defaultValuesOverride?.examCourses ?? [],
    eventEndDate: {
      type: defaultValuesOverride?.eventEndDate?.type ?? null,
      date: defaultValuesOverride?.eventEndDate?.date ?? null,
    },
    eventStartDate: defaultValuesOverride?.eventStartDate ?? null,
    location: {
      locationName: defaultValuesOverride?.location?.locationName ?? null,
      province: defaultValuesOverride?.location?.province ?? null,
      room: defaultValuesOverride?.location?.room ?? {},
      seat: defaultValuesOverride?.location?.seat ?? null,
    },
    mainProctors: defaultValuesOverride?.mainProctors ?? [],
    groupType: defaultValuesOverride?.groupType ?? null,
    groupCode: defaultValuesOverride?.groupCode ?? '',
  };

  return defaultValues;
}
